/* CARE PUREE LP */

/* 購入導線バーは画面下に固定しっぱなし（フッターの上でも停めない）。
   2026-09-04 ユーザー指示で停車の処理を削除した。
   フッターに被らないぶんは cplp.css でフッターの下アキを広げて逃がしている。 */

/* 動きを減らす設定のときは、スクロールのアニメーションもやめる */
function prefersReducedMotion() {
	return window.matchMedia
		&& window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/* カルーセルの送り／戻しボタンとドット。
   2026-09-17 レビュー修正でループに変更: ボタンは常に出し、先頭で「‹」を押すと最後へ、
   最後で「›」を押すと先頭へ巻き戻す（スクロールで流れて戻る）。
   ドットはカードの枚数ぶんここで作り、現在位置に aria-current を付ける。

   n枚目の位置は「n × 1枚ぶんの送り幅」。トラックの左右に（カラム幅 − カード幅）÷2 の
   余白を入れてあるので、どのカードも中央に止まり、スクロールの最大値も (枚数−1) × 送り幅に一致する。 */
(function () {
	"use strict";

	["point", "lineup"].forEach(function (key) {
		var track = document.querySelector(".cplp-" + key + "__track");
		var prev = document.querySelector(".cplp-" + key + "__prev");
		var next = document.querySelector(".cplp-" + key + "__next");
		var dotsBox = document.querySelector(".cplp-" + key + "__dots");
		if (!track || !prev || !next) return;

		var slides = track.querySelectorAll(".cplp-" + key + "__slide");
		var count = slides.length;
		if (count === 0) return;

		function pitch() {
			return slides[0].getBoundingClientRect().width
				+ parseFloat(getComputedStyle(track).columnGap || 0);
		}

		// いま中央に来ているカードの番号（スワイプ途中でもいちばん近いもの）
		function current() {
			var w = pitch();
			if (w <= 0) return 0;
			return Math.max(0, Math.min(count - 1, Math.round(track.scrollLeft / w)));
		}

		/* ボタン・ドットで動かしたときは、行き先のドットをすぐ点けて、着くまでそのままにする。
		   スクロールの位置で追いかけると、端から端へ巻き戻す間に途中のドットが順に点いてしまう。
		   着いたら（または1秒たったら）実際の位置に戻す。途中で指で止められても固まらないように */
		var target = -1;
		var targetTimer = 0;

		function show(index) {
			target = index;
			mark(index);
			window.clearTimeout(targetTimer);
			targetTimer = window.setTimeout(function () {
				target = -1;
				mark(current());
			}, 1000);

			var max = track.scrollWidth - track.clientWidth;
			track.scrollTo({
				left: Math.max(0, Math.min(index * pitch(), max)),
				behavior: prefersReducedMotion() ? "auto" : "smooth"
			});
		}

		// 端ではもう一方の端へ（％で回すと -1 → 最後、count → 先頭）。
		// 移動中にもう一度押されたら、途中の位置ではなく行き先から数える（連打で飛ばない）
		function go(dir) {
			var from = target >= 0 ? target : current();
			show((from + dir + count) % count);
		}

		prev.addEventListener("click", function () { go(-1); });
		next.addEventListener("click", function () { go(1); });

		// --- ドット ---
		var dots = [];
		if (dotsBox) {
			for (var n = 0; n < count; n++) {
				var b = document.createElement("button");
				b.type = "button";
				b.setAttribute("aria-label", (n + 1) + "枚目を表示（全" + count + "枚）");
				b.addEventListener("click", show.bind(null, n));
				dotsBox.appendChild(b);
				dots.push(b);
			}
		}

		var shown = -1;
		function mark(at) {
			if (at === shown) return;          // 変わったときだけ書き換える
			shown = at;
			dots.forEach(function (d, k) {
				if (k === at) d.setAttribute("aria-current", "true");
				else d.removeAttribute("aria-current");
			});
		}

		// 指でスワイプしたときは位置から現在地を出す。ボタンで移動中は行き先に着くまで待つ
		function sync() {
			var at = current();
			if (target >= 0) {
				if (at !== target) return;
				target = -1;
				window.clearTimeout(targetTimer);
			}
			mark(at);
		}

		// ボタンで移動中に指やホイールで触られたら、行き先待ちをやめて実際の位置に合わせる。
		// これが無いと、途中で逆向きに戻されても最大1秒ドットが行き先のまま残る（Codexレビュー指摘）
		function release() {
			if (target < 0) return;
			target = -1;
			window.clearTimeout(targetTimer);
			mark(current());
		}
		track.addEventListener("pointerdown", release, { passive: true });
		track.addEventListener("wheel", release, { passive: true });

		// scroll イベントはブラウザが1フレームに1回にまとめて送ってくるので、
		// requestAnimationFrame で間引く必要はない（処理も数値の比較とドットの付け替えだけ）
		track.addEventListener("scroll", sync, { passive: true });
		window.addEventListener("resize", sync, { passive: true });
		sync();
	});
})();

/* ページ内リンク（左ナビ・購入バー）をなめらかに送る。
   停止位置は CSS の scroll-margin-top で決めるので、テーマ側のヘッダーが
   固定表示になっている場合はそこの値だけ直せばよい。 */
(function () {
	"use strict";

	var links = document.querySelectorAll(".cplp a[href^=\"#\"]");
	Array.prototype.forEach.call(links, function (a) {
		var id = a.getAttribute("href");
		if (!id || id.length < 2) return;          // href="#" は購入URL未定のプレースホルダ
		a.addEventListener("click", function (e) {
			var target = document.querySelector(id);
			if (!target) return;
			e.preventDefault();
			target.scrollIntoView({
				behavior: prefersReducedMotion() ? "auto" : "smooth",
				block: "start"
			});
		});
	});
})();

/* 左右の追従カラムを、フッターの横まで下りて来られるようにする。
   グリッドの行をフッターの高さぶん伸ばすと sticky の可動域が伸びる（→ cplp.css）。
   フッターの高さはテーマ側の設定と文言で変わるので、実測して渡すしかない。

   注意: このスクリプトはセクションの末尾で走るので、**その時点ではフッターがまだ無い**。
   最初に一度 querySelector しただけだと必ず null になる（実際それで動かなかった）。
   DOMContentLoaded 以降に測り直すこと。 */
(function () {
	"use strict";

	var observed = false;

	function sync() {
		var cplp = document.querySelector(".cplp");
		if (!cplp) return;

		/* .cplp より下に残っている高さ（フッターと、その後ろにあるもの全部）。
		   伸ばした行は .cplp からはみ出すだけで .cplp の高さを変えないので、
		   この測り方は何度実行しても同じ値になる（自分の変更で値がぶれない）。 */
		var below = document.documentElement.scrollHeight
			- (cplp.getBoundingClientRect().bottom + window.pageYOffset);
		if (below < 0) below = 0;
		cplp.style.setProperty("--cplp-footer-h", Math.round(below) + "px");

		var footer = document.querySelector(".shopify-section-group-footer-group");
		if (footer && window.ResizeObserver && !observed) {
			observed = true;
			new ResizeObserver(sync).observe(footer);
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", sync);
	} else {
		sync();
	}
	// Webフォントや画像が入るとフッターの高さが変わるので、読み込み後にもう一度測る
	window.addEventListener("load", sync);
	window.addEventListener("resize", sync, { passive: true });
})();
